import React from 'react'
import { Wrapper, Image, Text } from './OrientationPopOver.style'
import type { OrientationPopOverProps } from './OrientationPopOver.types'
import ClickOutSide from 'utils/ClickOutSide'
import { Cdn } from 'utils/assets'
import { Trans, useTranslation } from 'i18n'
import useUserPlatform from 'utils/hooks/use-platform'
import { tokens } from '@arvoreeducacao/bonsai-core'

const OrientationPopOver: React.FC<OrientationPopOverProps> = ({
  open,
  onClickOutSide
}) => {
  const { t } = useTranslation()
  const { windowWidth } = useUserPlatform()

  if (!open || windowWidth <= tokens.breakpoints.tabletSmall) {
    return null
  }

  return (
    <ClickOutSide onClickOutSide={onClickOutSide}>
      <Wrapper>
        <Image
          src={Cdn.getImageUrl(t('my-readings/ilustra-marcar-como-lido.webp'))}
        />
        <Text>
          <Trans
            i18nKey={
              'Para <strong>marcar um livro como lido</strong>, basta clicar nos 3 pontinhos abaixo do livro e selecionar "marcar como lido". Isso fará com que ele vá para a sessão de Lidos.'
            }
          />
        </Text>
      </Wrapper>
    </ClickOutSide>
  )
}
export default OrientationPopOver
